import type { FaireProductEntity } from "../../entity_types/product";

export const p_jwpq7757cp: FaireProductEntity = {
  token: "p_jwpq7757cp",
  type: "product",
  name: "Pink Baby Bow Ribbon Ties Sweater Cardigan",
  brandToken: "b_xvvfvktx6s",
  brandName: "Rylee Faith Designs",
  imageUrl:
    "https://cdn.faire.com/fastly/517194a58adc64f055d1c52381ad295cae23f07e5bdada264f2547638da8049e.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/174b8ac1194aeed1b7a4e34ca27075fac28cafd45ded835e25438600a97eac4d.jpeg",
    "https://cdn.faire.com/fastly/4bc59c395f04e7bde8329743b4cc3c513ff95806acf3f1da816e8f2c2914bee5.jpeg",
    "https://cdn.faire.com/fastly/dcec20f67c985e43ce0e42bdeea415c8ee88110aae17a572065d1928fd9010fe.jpeg",
    "https://cdn.faire.com/fastly/a8ad12b70f2ff49884896b3f5936454a5277a886c8426557ccb1535903adb99d.jpeg",
    "https://cdn.faire.com/fastly/3c9aa836f9b3830077fd125c3d65e3fd9b17c27e92965077e19fe34f3311f780.jpeg",
    "https://cdn.faire.com/fastly/75e12d843583b9c1c5dba8c30aa04357f687e1e3994db1859a09a0026d8fd309.jpeg",
    "https://cdn.faire.com/fastly/9be66ad708dde19d75d0a9b528bec4446bc4402c6feb4ad4b6ef5dc54b9477ba.jpeg",
    "https://cdn.faire.com/fastly/f4ef37bb0c49027fca9650ecc4e2fde61fb3474e88b1238258e532ca2f1e5341.jpeg",
    "https://cdn.faire.com/fastly/13430107a571b91a9f06b680203ab4d4e574f3dcace14bdbb18e6826703e1d6f.jpeg",
  ],
  priceDollars: 23,
  description:
    "This charming pink baby cardigan features delicate bow ribbon ties that add a sweet, stylish touch while keeping your little one cozy. Crafted for softness and comfort, it’s perfect for layering in cooler weather and making any outfit adorable and complete. Easy to wear and gentle on sensitive skin, this cardigan is a must-have for your baby’s wardrobe.\n\nSKU:TPG60028\n\n\nMaterial:Viscose 50%, PBT 31%, Nylon 19%\n\n\n",
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:57:43.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
